module.exports = __webpack_public_path__ + "b-arrow.svg?69eff26806ff6785390962cfc2a5a156";